import { Component } from '@angular/core';
import { BrokerPortalFeatureCodes } from '@brokerportal/common/enums';
import { FeatureFlagService } from '@brokerportal/common/services';
import { CustomBroadcastChannel } from '@brokerportal/common/services/custom-broadcast-channel';
import { GLOBAL_CONSTANTS } from 'app/constants';

@Component({
    selector: 'bp-toolbar-user-button',
    templateUrl: './toolbar-user-button.component.html',
    styleUrls: ['./toolbar-user-button.component.scss']
})
export class ToolbarUserButtonComponent {
    isOpen: boolean;
    displayName: string;
    private $zoho = window['$zoho'] || {};

    constructor(private bc: CustomBroadcastChannel, private featureFlagService: FeatureFlagService) {}

    toggleDropdown() {
        this.isOpen = !this.isOpen;
    }

    onClickOutside() {
        this.isOpen = false;
    }

    handleLogout() {
        this.resetChatBox();
        this.bc.postMessage(GLOBAL_CONSTANTS.CHANNEL.USER.LOGOUT);
    }

    private resetChatBox() {
        try {
            if (this.$zoho && window['$ZSIQWidget'] !== undefined) {
                this.$zoho.salesiq?.reset();
            }
        } catch (error) {
            // Don't block logout if Zoho chat widget reset fails
            console.error('Error resetting Zoho chat widget:', error);
        }
    }
}
